import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {IGameScript} from '@specials/gcs-engine';

import {ClickerAudioPlayer} from '../ClickerAudioPlayer';
import {ClickerGameSpawner} from '../ClickerGameSpawner';

export class ResultsStartUpScript implements IGameScript {
  constructor(private readonly spawner: ClickerGameSpawner, private readonly audioPlayer: ClickerAudioPlayer) {}

  public create(): void {
    this.spawner.spawnEmittersContainer();
    this.spawner.spawnResultsBackground();
    this.spawner.spawnResultsSpaceship();
    this.spawner.spawnBonusDestroyEffect();
    this.spawner.spawnEmittersContainer();
  }

  public start(): void {
    this.audioPlayer.startPlayAudio();
  }

  public destroy(): void {
    this.audioPlayer.stopPlayAudio();
  }
}

injected(ResultsStartUpScript, DI_TOKENS.clickerGameSpawner, DI_TOKENS.clickerGameAudioPlayer);
